export let checkMailCampaignUser = () => {
  let emailCampaignUser = sessionStorage.getItem("emailCampaignUser");
  let mailCampaignUserCheck = emailCampaignUser ? true : false;
  return mailCampaignUserCheck;
};
